import { Component } from '@angular/core';

@Component({
  selector: 'about-us',
  templateUrl: './aboutus.tpl.html'
})
export class AboutusComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// ./src/app/about_us/aboutus.component.ts